export default __webpack_public_path__ + "static/media/USER_ICON23.7be199bd.svg";